import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { first } from 'lodash';
import ReactTooltip from 'react-tooltip';

const CompanyList = ({ company, users = [] }) => {
  const userArray = users.filter(
    item => item.user_id === company.audit.updated_by,
  );

  const user = userArray.length !== 0 ? first(userArray) : undefined;

  return (
    <React.Fragment>
      <td>
        <Link to={`/update-company/${company.company_id}`}>{company.name}</Link>
      </td>
      <td>{company.city}</td>
      <td>
        {company.places && company.places.length > 0 ? (
          <React.Fragment>
            <p data-tip data-for={company.company_id}>
              {`${company.places[0].name}${company.places.length > 1 ? ' ...' : ''}`}
            </p>
            <ReactTooltip id={company.company_id} place="top" type="dark" effect="float">
              {company.places.map(place => (
                <p key={place.name}>{place.name}</p>
              ))}
            </ReactTooltip>
          </React.Fragment>
        ) : (
          '-'
        )}
      </td>
      <td>{company.counts ?? '-'}</td>
      <td>{company.status ?? '-'}</td>
      <td>
        {user ? user.full_name : company.audit.updated_by}
      </td>
      <td>{moment(company.audit.updated_at).format('lll')}</td>
    </React.Fragment>
  );
};

export default CompanyList;
